export default __webpack_public_path__ + "static/media/transfer.25c8f01e.svg";